








import { Vue, Component } from "vue-property-decorator";
import DefaultLayout from "@/layouts/Default.vue";

@Component({
  components: {},
})
export default class App extends Vue {
  get currentLayout() {
    return this.$route?.meta?.layout || DefaultLayout;
  }
}
